import { Card, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import { ROUTES } from "Constants/AllRoutes";

export const OGDescriptionCard = ({ title, role, description }) => {
  const { Text, Paragraph } = Typography;
  const navigate = useNavigate();

  return (
    <Card
      className="og-description-card"
      hoverable
      title={
        <Text
          style={{ whiteSpace: "normal", wordBreak: "break-word" }}
          className="text-lg text-center"
        >
          {title}
        </Text>
      }
      style={{ flex: 1, margin: "0.5em", minWidth: "20em", minHeight: "5em" }}
      onClick={() => navigate(ROUTES.PROFILE_FORM, { state: { role } })}
    >
      <Paragraph
        type="secondary"
        className="text-center"
        style={{ marginBottom: 0, color: "grey", fontSize: "1.1em" }}
      >
        {description}
      </Paragraph>
    </Card>
  );
};
